import { useClient } from '../../core/client/ClientProvider'

export type ClientTextKey = 'welcomeMessage' | 'chatPlaceholder' | 'footerText'

export const useClientText = () => {
  const { config } = useClient()

  const getClientText = (key: ClientTextKey, fallback?: string): string => {
    return config?.theme.customTexts[key] || fallback || ''
  }

  const welcomeMessage = config?.theme.customTexts.welcomeMessage || ''
  const chatPlaceholder = config?.theme.customTexts.chatPlaceholder || ''
  const footerText = config?.theme.customTexts.footerText || ''
  const companyName = config?.theme.branding.companyName || ''
  const tagline = config?.theme.branding.tagline || ''
  const supportEmail = config?.theme.branding.supportEmail || ''
  const logoUrl = config?.theme.branding.logoUrl || ''
  const backgroundImage = config?.theme.branding.backgroundImage || ''

  return {
    getClientText,
    welcomeMessage,
    chatPlaceholder,
    footerText,
    companyName,
    tagline,
    supportEmail,
    logoUrl,
    backgroundImage,
  }
}
